module.exports = __webpack_public_path__ + "img/email.a1acdbd8.svg";